import { Height } from "@mui/icons-material";

export const styleModalFirma = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: 'none',//'2px solid #ff',
    boxShadow: 24,
    p: 4,
};

export const styleModalAsignaCausas = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    border: 'none',//'2px solid #ff',
    boxShadow: 24,
    p: 4,
}

export const styleModalValidaCausa = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: '60%',
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 3,
    borderRadius: 2,
    maxHeight: "80vh",   // 👉 límite de altura
    overflow: "auto",    // 👉 activa scroll interno
}